import { Typography, Stack, Container, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import MuiDataTable from "../../components/muidatatable";
import MuiSearch from "../../components/muisearch";
import MuiButton from "../../components/muibutton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { getAPI } from "../../services/basehttpAPI";
import { useNavigate } from "react-router-dom";
import * as BusinessConst from "../../utils/businessconstants"
import MuiTabs from "../../components/muitabs";
import ShipToPartyList from "./shiptoparties/shiptopartylist";



const CustomerProfileList = () => {
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  //always pass id, label, align property
  const columnHeaders = [
    { id: "id", label: "#", align: "left", enableSort: true },
    {
      id: "customerName",
      label: translatedText?.customer_name,
      align: "left",
      enableSort: true,
      style: "bold",
    },
    { id: "indasCustomerId", label: translatedText?.indas_customer_id, align: "left", enableSort: true },
    {
      id: "connectedUsers",
      label: translatedText?.connected_users,
      align: "left",
      enableSort: true,
    },
    { id: "action", label: translatedText?.action, align: "left", pagekey: BusinessConst.pagekey_customerprofilelist, enableSort: false, },
  ];
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [initialData, setInitialData] = useState([]);

  const getCustomerProfileList = async () => {
    let url = "CustomerProfile/GetAllCustomerProfile";
    const response = await getAPI(url, null);
    setDataList(response.responseData);
    setInitialData(response.responseData);
  };

  useEffect(() => {
    getCustomerProfileList();
  }, []);

  useEffect(() => {
    const filteredList = filterData(searchValue);
    setDataList(filteredList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const filterData = (searchValue) => {
    if (searchValue === "") {
      return initialData;
    }
    return initialData.filter(
      (d) =>
        d.customerName.toLowerCase().includes(searchValue.toLowerCase()) ||
        d.indasCustomerId.toLowerCase().includes(searchValue.toLowerCase())
    );
  };
  const handleNavigation = () => {
    navigate("/layout/addcustomer");
  }
  const renderCustomerProfileList = () => {
    let customerProfileContent = dataList?.length > 0 ? (
      <>
        <Container maxWidth="xl" sx={{ width: "100%" }}>
          <Stack direction="row" spacing={2} paddingBottom={"30px"}>
            <Typography variant="h5" flexGrow={1}>
              {" "}
              {translatedText?.customer_profiles}
            </Typography>
            <MuiButton
              text={translatedText?.add_customer}
              color="success"
              onClick={handleNavigation}
              show={true}
            />
          </Stack>
          <Box>
            <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} />
            <MuiDataTable headerdata={columnHeaders} rowData={dataList} />
          </Box>
        </Container>
      </>
    ) : (
      <Container maxWidth="xl" sx={{ width: "100%" }}>
        <Stack direction="row" spacing={2} paddingBottom={"30px"}>
          <Typography variant="h5" flexGrow={1}>
            {" "}
            {translatedText?.customer_profiles}
          </Typography>
          <MuiButton
            text={translatedText?.add_customer}
            color="success"
            onClick={handleNavigation}
            show={true}
          />
        </Stack>
        <Box>
          <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} />
        </Box>
        <Card>
          <CardContent>
            <Typography variant="h6" align="center" component="div">
              {translatedText.no_records_found} {/*No Records Found*/}
            </Typography>
          </CardContent>
        </Card>
      </Container>
    );
    const tabData = [
      {
        label: translatedText?.customer_profiles,
        content: customerProfileContent,
      },
      {
        label: translatedText?.shiptoparty_list,
        content: (
          <Typography component={"div"}>
            <ShipToPartyList />
          </Typography>
        )
      }
    ];
    return <>
        <MuiTabs tabs={tabData} />
      </>
  }

  return (
    renderCustomerProfileList()
  )

};
export default CustomerProfileList;
